import React, { useState } from "react";
import { presignAndUpload } from "../utils/s3";

export default function UploadProof({ onUploaded, label = "Upload Proof" }) {
  const [fileName, setFileName] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const onChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true); setError("");
    try {
      const res = await presignAndUpload(file); // {key, url}
      setFileName(file.name);
      onUploaded && onUploaded(res);
    } catch (err) {
      setError(err?.message || "Upload failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex items-center gap-2">
      <label className="btn btn-sm btn-primary cursor-pointer">
        {busy ? "Uploading..." : label}
        <input type="file" style={{ display: "none" }} onChange={onChange} />
      </label>
      {fileName && <span className="text-xs opacity-70">{fileName}</span>}
      {error && <span className="text-xs text-red-600">{error}</span>}
    </div>
  );
}
